
import { Component } from "vue-property-decorator";
import OverviewCellBase from "@/app/dynamic-components/overviews/cells/overview-cell.base";
import { getObjectContentsFromPath } from "@/app/helpers/stringpath.helper";

@Component({
  components: {},
})
export default class OverviewCellCategory extends OverviewCellBase {
  get chipColor(): string {
    return this.metadata["color"] ? this.metadata["color"] : "primary";
  }

  get cellText(): string {
    return (
      (this.metadata["translate"] ? this.$t(this.value) : this.value) || "-"
    );
  }

  protected PostResolveValue() {
    if (this.metadata?.translateList && this.value) {
      //entry in dataresolver
      let path = this.metadata.translateList;
      if (path.startsWith("data.")) {
        path = path.replace("data.", "");
      }
      const resolvedItems = getObjectContentsFromPath(
        path,
        this.additionalMetadata
      );
      if (Array.isArray(resolvedItems)) {
        resolvedItems
          .filter((it) => {
            return this.value === it[this.metadata.itemValue];
          })
          .forEach((value) => {
            this.value = value[this.metadata.itemText];
          });
      }
    }
  }
}
